export default __webpack_public_path__ + "static/media/element_52.61acff70.avif";